<template>
    <SKModal
        ref="modal"
        :fullscreen="false"
        actionButtonsPosition="right"
        :hasAcceptButton="true"
        :accept-callback="save"
        :title="$t('admin.users.actions.change_email')"
    >
        <template v-slot:body>
            <vs-input
                :label="$t('apps.registered-users.email')"
                type="email"
                class="mt-4 w-full border-grey-light"
                v-model="email"
                :required="true"
            />
        </template>
    </SKModal>
</template>
<script>

import SKModal from "@/modules/Shared/Components/modal/SKModal";
import loader from "@/modules/Shared/Mixins/loader";
import UsersService from "@/modules/Admin/Services/UsersService";

export default {
    name: 'ChangeUserEmailModal',
    mixins: [loader],
    props: {
        user: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            email: '',
        }
    },
    components: {
        SKModal,
    },
    created() {
        this.email = this.user.email
    },
    methods: {
        async save() {
            const payload = {
                email: this.email,
                can_impersonate: false,
                language: this.user.language,
                timezone: this.user.timezone
            }

            if (this.user.firstname) {
                payload.firstname = this.user.firstname
            }

            if (this.user.lastname) {
                payload.lastname = this.user.lastname
            }

            await this.loadAndNotify(async () => {
                await UsersService.editUser(this.user.uuid, payload)
                this.$emit('update')
            })
        },
        async open() {
            this.email = this.user.email
            this.$refs['modal'].open()
        },
    },
}
</script>
